/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetRedlineUsageQueryResponse, ReportingControllerGetRedlineUsageQueryParams, ReportingControllerGetRedlineUsage400, ReportingControllerGetRedlineUsage401, ReportingControllerGetRedlineUsage403, ReportingControllerGetRedlineUsage404 } from "../../models/reportingController/ReportingControllerGetRedlineUsage";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { reportingControllerGetRedlineUsage } from "../../clients/reportingService/reportingControllerGetRedlineUsage";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const reportingControllerGetRedlineUsageQueryKey = (params: ReportingControllerGetRedlineUsageQueryParams) => [{
  url: '/api/v1/reporting/redlines'
}, ...(params ? [params] : [])] as const;
export type ReportingControllerGetRedlineUsageQueryKey = ReturnType<typeof reportingControllerGetRedlineUsageQueryKey>;
export function reportingControllerGetRedlineUsageQueryOptions(params: ReportingControllerGetRedlineUsageQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = reportingControllerGetRedlineUsageQueryKey(params);
  return queryOptions<ReportingControllerGetRedlineUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetRedlineUsage400 | ReportingControllerGetRedlineUsage401 | ReportingControllerGetRedlineUsage403 | ReportingControllerGetRedlineUsage404>, ReportingControllerGetRedlineUsageQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return reportingControllerGetRedlineUsage(params, config);
    }
  });
}

/**
 * @summary Get redlining usage for an organization: redlines run, distinct users, a per-team breakdown, a bucketed series and the previous-period comparison. Honors the team and date filters.
 * {@link /api/v1/reporting/redlines}
 */
export function useReportingControllerGetRedlineUsage<TData = ReportingControllerGetRedlineUsageQueryResponse, TQueryData = ReportingControllerGetRedlineUsageQueryResponse, TQueryKey extends QueryKey = ReportingControllerGetRedlineUsageQueryKey>(params: ReportingControllerGetRedlineUsageQueryParams, options: {
  query?: Partial<QueryObserverOptions<ReportingControllerGetRedlineUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetRedlineUsage400 | ReportingControllerGetRedlineUsage401 | ReportingControllerGetRedlineUsage403 | ReportingControllerGetRedlineUsage404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? reportingControllerGetRedlineUsageQueryKey(params);
  const query = useQuery({
    ...reportingControllerGetRedlineUsageQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ReportingControllerGetRedlineUsage400 | ReportingControllerGetRedlineUsage401 | ReportingControllerGetRedlineUsage403 | ReportingControllerGetRedlineUsage404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}